import { Dispatch, SetStateAction } from 'react';

import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';

export const bookingSearchAndPageChangeUtils = (
    filteredBookingData: QueueSheetManagementRows[],
    currentSize: number,
    currentPage: number,
    setCurrentPage: Dispatch<SetStateAction<number>>,
    searchValue: string,
    setSearchValue: Dispatch<SetStateAction<string>>,
    setCurrentSize: Dispatch<SetStateAction<number>>
) => {
    const totalItems = filteredBookingData?.length ?? 0;
    const totalPages = Math.ceil(totalItems / currentSize);
    const bookingData = filteredBookingData ?? [];

    const handlePageChange = (page: number) => setCurrentPage(page);
    const handlePageSizeChange = (size: number) => {
        setCurrentSize(size);
        setCurrentPage(0); // Reset to page 0 when changing page size
    };
    const handleSearchChange = (value: string) => {
        if (value !== searchValue) {
            setSearchValue(value);
            setCurrentPage(0); // Reset to page 0 when search changes
        }
    };
    return {
        totalItems,
        totalPages,
        bookingData,
        handlePageChange,
        handlePageSizeChange,
        handleSearchChange,
    };
};
